'use client';

import { Link, Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';
import { ReactElement } from 'react';

export default function LoginLink({ logInUrl }: { logInUrl: string }): ReactElement {
  const { Trans, t } = useTranslation('webshop.wishlist');

  return (
    <Typography>
      <Trans
        t={t}
        i18nKey='toSaveWishlist'
        components={{
          logIn: <Link href={logInUrl} />
        }}
      />
    </Typography>
  );
}
